<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="dashboard-container ">

   <div class="dashboard-header">
      <h2>{{ hospitalName }}</h2>
      <div class="header-actions">
         <span class="material-icons">expand_more</span>
      </div>
   </div>

   <div class="top-grid">

      <div class="card performance-card">
         <div class="card-header">
            <h3>Hospital Performance</h3>
            <span class="material-icons icon">bar_chart</span>
         </div>

         <div class="performance-body">
            <div class="bar-chart-container">
               <div class="y-axis">
                  <span>10</span><span>5</span><span>0</span>
               </div>
               <div class="bars">
                  <div class="bar" style="height: 30%"></div>
                  <div class="bar" style="height: 50%"></div>
                  <div class="bar" style="height: 80%"></div>
                  <div class="bar active" style="height: 100%"></div>
               </div>
               <div class="x-axis-label">Visit Rate</div>
            </div>

            <div class="progress-list">
               <div class="progress-item" *ngFor="let metric of performanceMetrics">
                  <div class="prog-label">
                     <span>{{ metric.label }}</span>
                     <span>{{ metric.percentage }}%</span>
                  </div>
                  <div class="progress-track">
                     <div class="progress-fill" [ngClass]="metric.colorClass" [style.width.%]="metric.percentage"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="card tasks-card">
         <div class="card-header">
            <h3>Updates & Tasks</h3>
            <span class="material-icons icon">assignment</span>
         </div>

         <table class="mini-table">
            <thead>
               <tr>
                  <th>Task</th>
                  <th>Due Date</th>
                  <th>Status</th>
               </tr>
            </thead>
            <tbody>
               <tr *ngFor="let task of miniTasks">
                  <td>{{ task.taskName }}</td>
                  <td>{{ task.date }}</td>
                  <td><span class="badge" [ngClass]="getStatusClass(task.status)">{{ task.status }}</span></td>
               </tr>
            </tbody>
         </table>
      </div>

   </div>

   <h3 class="section-title">Your Hospital's Goals</h3>

   <div class="goals-list">
      <div class="goal-card" *ngFor="let goal of activeGoals">

         <div class="goal-info">
            <h4>{{ goal.title }}</h4>
            <span class="subtitle">TOOLS & RESOURCES TO BE SUCCESSFUL</span>

            <ul class="links-grid">
               <li *ngFor="let link of goal.links">
                  <span class="material-icons">arrow_circle_right</span> {{ link }}
               </li>
            </ul>
         </div>

         <div class="goal-stats">
            <div class="stat-text">
               <div class="big-number">{{ goal.currentValue }}</div>
               <div class="stat-label">{{ goal.subTitle }}</div>
               <div class="goal-target">{{ goal.goalValue }}</div>
            </div>
            <div class="mini-graph-placeholder">
               <svg viewBox="0 0 100 40" class="line-chart">
                  <polyline fill="none" stroke="#ffcc80" stroke-width="2" points="0,40 20,35 40,25 60,20 80,10 100,5" />
                  <polygon fill="#fff3e0" points="0,40 20,35 40,25 60,20 80,10 100,5 100,40 0,40" />
               </svg>
            </div>
         </div>

      </div>
   </div>

   <h3 class="section-title">Your Goals from Last Quarter</h3>
   <div class="goals-list">
      <div class="goal-card" *ngFor="let goal of pastGoals">
         <div class="goal-info">
            <h4>{{ goal.title }}</h4>
            <span class="subtitle">TOOLS & RESOURCES TO BE SUCCESSFUL</span>
            <ul class="links-grid">
               <li *ngFor="let link of goal.links"><span class="material-icons">arrow_circle_right</span> {{ link
                  }}</li>
            </ul>
         </div>
         <div class="goal-stats">
            <div class="stat-text">
               <div class="big-number">{{ goal.currentValue }}</div>
               <div class="stat-label">{{ goal.subTitle }}</div>
               <div class="goal-target success">{{ goal.goalValue }}</div>
            </div>
            <div class="mini-graph-placeholder">
               <span class="material-icons success-icon">emoji_events</span>
            </div>
         </div>
      </div>
   </div>

</div>